import React from 'react';
import { Button } from '../actions/Button.jsx';
export function Dialog({open=true, title, description, onClose, onConfirm, confirmLabel='Confirm', cancelLabel='Cancel', hideCancel, danger, inline, children, style}) {
  if (!open) return null;
  return <div onClick={onClose} style={{position:inline?'relative':'fixed',inset:0,background:'rgba(14,27,20,.45)',display:'grid',placeItems:'center',zIndex:100,fontFamily:'var(--font-sans)',...(inline?{padding:24,borderRadius:'var(--radius-lg)'}:{})}}>
    <div onClick={e=>e.stopPropagation()} style={{background:'var(--surface)',borderRadius:'var(--radius-lg)',boxShadow:'var(--shadow-lg)',width:440,maxWidth:'calc(100vw - 48px)',padding:24,display:'flex',flexDirection:'column',gap:12,...style}}>
      <div style={{fontWeight:600,fontSize:'var(--text-h3)'}}>{title}</div>
      {description && <div style={{fontSize:'var(--text-sm)',color:'var(--text-muted)',lineHeight:'var(--leading-normal)'}}>{description}</div>}
      {children}
      <div style={{display:'flex',gap:10,justifyContent:'flex-end',marginTop:8}}>
        {!hideCancel && <Button variant="secondary" onClick={onClose}>{cancelLabel}</Button>}
        <Button variant={danger?'danger':'solid'} onClick={onConfirm}>{confirmLabel}</Button>
      </div>
    </div>
  </div>;
}
